<template>
  <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
    <span v-if="selected_text == 0" id="text_title">Hallo daar,</span>
    <span v-html="texts[selected_text]" id="text_description" :style="selected_text > 0 ? 'margin-top: 15%;' : ''"></span>
    <img  draggable="false" id="text_background_many" src="./../assets/images/Asset 36.png" alt="">
    <img  draggable="false" class="clickable" v-show=" ! $store.getters['app/overlays'].skip_intro ? texts.length == (selected_text + 1) : true" @click="goToGameSelect()" id="play_start_btn_many" src="./../assets/images/Asset 37.png" alt="">
    <img  draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../assets/images/Asset 51.png" alt="">
    <img  draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../assets/images/Asset 51.png" alt="">
    <img  draggable="false" class="clickable" @click="goToHome()" id="top_quit_btn_many" src="./../assets/images/Asset 31.png" alt="">
  </span>
</template>

<script>
export default {
  name: "Home",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: 0,
      texts: [
        "Wist je dat water super belangrijk is voor ons? Het is echt overal om ons heen. We gebruiken het om te zwemmen en lekker schoon te worden in bad of onder de douche. En natuurlijk om te drinken als we dorst hebben. Dat koele water kan echt heerlijk zijn op een warme dag! <br><br> In Suriname hebben we echt geluk, want ons water is meestal heel schoon en helder. Dat is niet overal zo, dus we moeten er goed voor zorgen.",

        "Wist je dat we zelf voor meer dan de helft uit water bestaan? Ja, echt waar! Ons lichaam heeft water nodig om goed te werken. Daarom is het slim om elke dag minstens 1 liter water te drinken. Het houdt ons gezond en helpt ons lichaam om voedingsstoffen uit ons eten op te nemen. <br><br> Wonen jullie in de buurt van een rivier of een stroom? Veel mensen in Suriname wel. Water is super handig, niet alleen om te drinken, maar ook om te wassen, te vissen en zelfs om te reizen. Dankzij speciale buizen en pompen kunnen we ook wonen waar minder water is.",

        "Wonen jullie in de buurt van een rivier of een stroom? Veel mensen in Suriname wel. Water is super handig, niet alleen om te drinken, maar ook om te wassen, te vissen en zelfs om te reizen. Dankzij speciale buizen en pompen kunnen we ook wonen waar minder water is. <br><br> De Surinaamse Waterleiding Maatschappij zorgt ervoor dat ons drinkwater schoon is. Maar helaas is dat niet overal zo. Sommige mensen gooien vuil zoals plastic zakken en flessen in het water. Dat is niet goed voor onze mooie rivieren en stromen.",

        "Er zijn ook problemen met water in andere delen van de wereld. In sommige gebieden is het water vies geworden door bacteriën en giftige stoffen. En soms stijgt het water te veel door regen, waardoor land overstroomt. Dat kan best eng zijn. <br><br> Maar we hebben een superheld in Suriname! Professor Naipal is een echte waterexpert. Hij werkt hard om ons land te beschermen tegen overstromingen en kusterosie (wanneer de zee het land opslokt). Hij doet dit door mangrovebomen te planten. Deze bomen breken de hoge golven van de zee, zodat ze ons niet overspoelen. Ze helpen ook de grond vast te houden, zodat we geen land verliezen",

        "Professor Naipal is zo slim en aardig dat hij zijn kennis deelt met studenten. Ze gaan samen op onderzoek en leren hoe belangrijk water is. Want zoals professor Naipal zegt, kennis is pas echt waardevol als je het kunt gebruiken. <br><br> Dus onthoud, water is kostbaar! Laten we goed voor ons water zorgen en professor Naipal en zijn team helpen om ons land te beschermen. Samen kunnen we veel avonturen beleven en onze wereld mooi houden!",

        "Op de vorige pagina hebben we geleerd hoe belangrijk water is in ons leven en hoe Professor Naipal ons helpt om de kust te beschermen met mangroven. Nu gaan we een leuk spel spelen om meer te ontdekken! <br><br> <h2>Klik op de rechter knop om door te gaan.</h2>",

        "<h1>Spel 1: Golven spel bij Mangrove Avontuur</h1> In dit spel gaan we ontdekken hoe mangroven ons kustgebied beschermen tegen woeste golven. <br><br> Bescherm de kust tegen de woeste golven die eraan komen spoelen. Hoe? Door super snel op die golven te klikken! Mocht er eentje aan je aandacht ontsnapt, maak je geen zorgen. We hebben mangroven die de kust beschermen. <br><br> Dus, zet je schrap, klik op die golven en zie hoe de mangroven de kust redden. ",

        "<h1>Spel 2: Hengelen in de Surinaamse Rivier</h1> Hengelen is als een groot avontuur vol geduld en opwinding! Het is net alsof je een mysterieuze schatkist uit het water tovert, want je weet nooit welke verrassing er aan je hengel zal hangen. Het kan een grote, glinsterende vis zijn, of misschien een kleine ondeugende vis die snel wegschiet. Maar, oh jee, soms vangen we ook dingen die niet thuishoren in de rivier.",

        "Het is belangrijk om goed voor de rivier en de vissen te zorgen, want soms gooien mensen per ongeluk rommel in het water. En dat is helemaal niet fijn voor onze visvriendjes. In dit spel gaan we samen hengelen, maar er is een speciale missie! We moeten ervoor zorgen dat we niet alleen vissen, maar ook al het andere dat we vangen, netjes scheiden. <br><br> Heb je iets gevangen dat niet in de rivier thuishoort? Geen probleem! We hebben een ton en een net om onze vangst mee naar huis te nemen. Laten we samen zorgen voor een schone en blije rivier, zodat de vissen veilig en gelukkig kunnen zwemmen. Ben je klaar voor het grote hengelavontuur? laten we beginnen!",

        "<br><br><br><h1>Klik op \"Play\" om te starten.</h1>"
      ]
    };
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: false,
      });
    },
    nextText() {
      this.selected_text++;
    },
    prevText() {
      this.selected_text--;
    },
    goToGameSelect() {
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: true,
      });
      this.$router.push('/game_select');
    }
  },

  computed: {}
};
</script>

<style>
  #text_background_many {
    position: absolute;
    margin-top: 0%;
    left: 9%;
    width: 80%;
    height: auto;
  }
  #play_start_btn_many {
    position: absolute;
    margin-top: 40%;
    left: 43%;
    width: 15%;
  }

  #next_btn {
    position: absolute;
    margin-top: 40%;
    left: 74%;
    width: 7%;
  }
  #prev_btn {
    transform: rotate(180deg);
    position: absolute;
    margin-top: 40%;
    left: 21%;
    width: 7%;
  }

  #top_quit_btn_many {
    position: absolute;
    margin-top: 3%;
    right: 3%;
    width: 10%;
    z-index: 2;
  }
</style>
